/**
 * Supplier contact service for API calls (supplier_contacts table).
 * @typedef {import('../models/SupplierContact').SupplierContactCreate} SupplierContactCreate
 * @typedef {import('../models/SupplierContact').SupplierContact} SupplierContact
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const getSupplierContacts = async (accessToken, supplierId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/suppliers/${supplierId}/contacts`,
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to get supplier contacts'
    );
  }
};

export const createSupplierContact = async (accessToken, supplierId, data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/suppliers/${supplierId}/contacts`,
      { supplier_contact: data },
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to create supplier contact'
    );
  }
};

export const updateSupplierContact = async (
  accessToken,
  contactId,
  data
) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/supplier-contacts/${contactId}`,
      { supplier_contact: data },
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to update supplier contact'
    );
  }
};

export const deleteSupplierContact = async (accessToken, contactId) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/api/supplier-contacts/${contactId}`,
      { headers: authHeaders(accessToken) }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || 'Failed to delete supplier contact'
    );
  }
};
